const AuctionTypes = [
  { id: "1", name: 'First Price' },
  { id: "2", name: 'Second Price Plus' }
];

export default AuctionTypes;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/StaticData/AuctionTypes.tsx